<eze-alert *ngIf="showAlert" [alert]="alert" [disableClose]="true"></eze-alert>